import HotTagList from './HotTagList.component';

export default HotTagList;
